<template>
  <base-modal
    :closeable-from-outside="false"
    hide-footer
    :size="'lg'"
    :modal-id="'survey-change-permission'"
    @hidden="$emit('onCloseModal')"
  >
    <template #modal-header>
      <div class="d-flex justify-content-between font-medium-4">
        <div>แก้ไขสิทธิ์การเข้าใช้งานเกม</div>
      </div>
    </template>
    <b-row>
      <b-col cols="12">
        <setting-permission
          :formData="modalData"
          :tagOption="tagOption"
          @onSelectTagVisibility="onSelectTagVisibility"
          @onInputDuplicateTag="onInputDuplicateTag"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="modal-btn-wrp btn-wrp mt-2 mb-2">
          <div class="d-flex justify-content-center mt-2">
            <cancel-button class="mr-1" @click.native="$emit('onCloseModal')" />
            <save-button
              :btnLabel="'Apply'"
              type="submit"
              class="ml-1 btn-save"
              @click.native="onChangePermission"
            />
          </div>
        </div>
      </b-col>
    </b-row>
  </base-modal>
</template>

<script>
import SettingPermission from "./SettingPermission.vue";
import {
  ref,
  reactive,
  computed,
  onBeforeMount,
  watch,
  getCurrentInstance,
} from "@vue/composition-api";
import { props } from "vue-prism-component";
export default {
  components: { SettingPermission },
  props: {
    modalData: { type: Object, default: {} },
    tagOption: { type: Object, default: {} },
  },
  setup(props) {
    const vm = getCurrentInstance().proxy;

    const onSelectTagVisibility = (tagVisibility) => {
      vm.$emit("onSelectTagVisibility", tagVisibility);
    };

    const onChangePermission = () => {
      vm.$emit("onChangePermission", props.modalData);
    };

    const onInputDuplicateTag = (isDuplicate) => {
      vm.$emit("onInputDuplicateTag", isDuplicate);
    };
    return {
      onSelectTagVisibility,
      onChangePermission,
      onInputDuplicateTag,
    };
  },
};
</script>

<style>
#survey-change-permission .modal-header {
  background-color: #fff !important;
  display: block;
  border-bottom: 1px solid #d8d6dd;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  padding: 15px 30px !important;
}

#survey-change-permission .modal-header > div {
  font-weight: bold;
  color: #000;
}

#survey-change-permission .modal-content {
  border-radius: 15px !important;
  width: 100%;
}

#survey-change-permission .modal-body {
  padding: 20px 30px !important;
}

#survey-change-permission .btn-save {
  background-color: #62bb70 !important;
  border-color: #62bb70 !important;
}

#survey-change-permission .save-button {
  padding: 13px 24px !important;
}

#survey-change-permission .vs__open-indicator {
  color: #728aac;
  fill: #728aac;
}
</style>